$('.wpcf7-submit').prop('disabled', true);
$('input[name="privacy"]').change(function () {
	// チェックが入っていたら有効化
	if ($(this).is(':checked')) {
		// ボタンを有効化
		$('.wpcf7-submit').prop('disabled', false);
		$('.wpcf7-submit').css('opacity', '1');
	} else {
		// ボタンを無効化
		$('.wpcf7-submit').prop('disabled', true);
		$('.wpcf7-submit').css('opacity', '0.5');
	}
});

$(function () {
	//二重送信抑制
	let submitBtn = $("input[type='submit'].wpcf7-submit");
	submitBtn.click(function () {
		$(this).css('pointer-events', 'none');
		$(this).css('opacity', '0.5');
	})
	// 入力項目にエラーがあったらボタン復活
	document.addEventListener('wpcf7invalid', function () {
		submitBtn.css('pointer-events', 'auto');
	}, false);

});


jQuery(document).ready(function () {
	jQuery(".wpcf7-form").validationEngine(
		'attach', {
		promptPosition: "topRight:-50"//エラーメッセージ位置の指定
	}
	);
});
jQuery(document).ready(function () {
	$('input[type="text"]').each(function () {
		// aria-required属性の値を取得
		var ariaRequired = $(this).attr('aria-required');

		// aria-requiredがtrueの場合
		if (ariaRequired === 'true') {
			// class="abc"を追加
			$(this).addClass("validate[required]");
		}
	});

	jQuery("input[type='email']").addClass("validate[required, custom[email]]");
	jQuery("input[type='tel']").addClass("validate[required,custom[phone]]");
});
